<app-dialog-heading [heading]="'Add Documents'"></app-dialog-heading>

<div class="flex items-center center-align">
  <app-element-select
    class="col-4 mr1"
    [options]="documentTypes"
    [displayLabel]="'Document Type'"
    [emitNameValueDTO]="true"
    [defaultValue]="selectedDocumentType"
    [required]="true"
    (selectionChanged)="onDocumentTypeChange($event)">
  </app-element-select>
  <app-file-upload [config]="fileUploadConfig"
                   (onUploadSuccess)="onFileUploadSuccess($event)">
  </app-file-upload>
</div>

<div *ngIf="isDataAvailable()">
  <table mat-table [dataSource]="documentDataSource" matSort class="mat-elevation-z8">

    <!-- Document Type Column -->
    <ng-container matColumnDef="documentType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Document Type</th>
      <td mat-cell *matCellDef="let document"> {{document.documentType?.name}} </td>
    </ng-container>

    <!-- File Name Column -->
    <ng-container matColumnDef="fileName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> File Name</th>
      <td mat-cell *matCellDef="let document"> {{document.fileName}} </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let document">
        <button mat-icon-button color="primary" (click)="onClickDownload(document)">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="onClickDelete(document)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Paginator -->
  <mat-paginator #documentPaginator
                 [pageSize]="5"
                 [pageSizeOptions]="[5]"
                 [length]="documentDataSource.data?.length">
  </mat-paginator>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="primary" (click)="onClickSave()">Okay</button>
  <button class="dialog-button" mat-raised-button color="warn" (click)="onClickCancel()">Cancel</button>
</mat-dialog-actions>

